import { IMessage } from '@sv-support-sdk/chat-shared-types/src/common/messages';

import { MESSAGE_USER_TYPES_LIST } from '../../constants/chatMessages';

export const divideMessageAndReply = (message: string = '') => {
  const replyRegex = /&#8618;\s"(.*?)"\n\n((.|\s)*)/gi;
  const replyAndMessageMach = Array.from(message.replace(/&amp;/g, '&').matchAll(replyRegex));
  return replyAndMessageMach.length && replyAndMessageMach[0].length
    ? {
      message: replyAndMessageMach[0][2].toString(),
      reply: replyAndMessageMach[0][1].toString(),
    }
    : {
      message,
    };
};

export const getLastMessage = (messages: IMessage[], fromStaff?: boolean) =>
  messages.reduce(
    (last: number, message: IMessage) =>
      message.id &&
      message.id > last &&
      (!fromStaff || !MESSAGE_USER_TYPES_LIST.includes(message.authorType))
        ? message.id
        : last,
    0,
  );

export const withoutHTML = (text: string) => text.replace(/<[^>]*>?/gm, '');
